import { state, patch } from "../../state/store.js";
import { sortChatsForList } from "../../views/Chat.helpers.ts";
import { apiFetch } from "./request.js";

export async function hydrateFromServer() {
  if (!state.authToken) return null;
  patch({ connectionStatus: "syncing" });
  const data = await apiFetch("/state");
  patch({
    user: data.user || state.user,
    userEmail: data.user?.email || state.userEmail,
    leads: Array.isArray(data.leads) ? data.leads : [],
    funnels: Array.isArray(data.funnels) && data.funnels.length ? data.funnels : state.funnels,
    activeFunnelId: data.activeFunnelId || state.activeFunnelId,
    whatsappSession: data.whatsappSession || null,
    chats: Array.isArray(data.whatsappChats) ? sortChatsForList(data.whatsappChats) : [],
    connectionStatus: "connected",
  });
  return data;
}
